<script lang="ts" setup>
    import Cms from "@/components/Cms.vue";
    import MarkdownEditor from "@/components/MarkdownEditor.vue";
    import { computed, } from "vue"   
    import { Head } from "@inertiajs/vue3"; 

    let props = defineProps({
        content: {
            type: Object,
            default: () => ({
                data: {
                    pageName: null,
                    metaDescription: "",
                    metaKeywords: ""
                }
            })
        }
    })
    let url = computed(()=>{
        
        let urlString = window.location.href?.replace(`${window.location.origin}`, "")
        urlString = urlString.replace("/preview", '')
        if(urlString.includes("/api/developer")) {
            return urlString.replace("/api/developer/", "")
        } else {
            return urlString
        }
    })
    let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": url.value
    }
})

let components = [
    {
        name: "Markdown Editor",
        component: MarkdownEditor,
        models: ["content-section"],
        inputs: [{
            name: "markdown",
            type: "longText",
        }]
    }
]

</script>
<template>
    <div class="cms-feature" style="padding: 1.5rem;">
        <Head>
            <title>{{content.data.pageName}}</title>
            <meta name="description" :content="content.data.metaDescription"/>
            <meta name="keywords" :content="content.data.metaKeywords"/>
        </Head>
        <cms content-prop="content" model="content-section" driver="builder" :readable-fields="['pageName']" :components="components" is-section :search-params="searchParams"/>
    </div>
</template>